// Add overlay to the body
const overlay = document.createElement('div');
overlay.classList.add('popup-overlay');
document.body.appendChild(overlay);

// Get the popup and close button
const popup = document.querySelector('.gallery-popup .popup');
const popupContent = document.getElementById('popup-content');
const closePopupBtn = document.getElementById('close-popup');

// Function to show the popup and overlay
function showPopup(content) {
  popupContent.textContent = content;   // Set the popup content
  overlay.style.display = 'block';      // Show overlay
  popup.style.display = 'block';        // Show popup
  document.documentElement.style.overflow = 'hidden';  // Disable html scrolling
}

// Function to hide the popup and overlay
function hidePopup() {
  overlay.style.display = 'none';       // Hide overlay
  popup.style.display = 'none';         // Hide popup
  document.documentElement.style.overflow = 'visible';  // Re-enable html scrolling
}

// Add event listener to close button
closePopupBtn.addEventListener('click', hidePopup);

// Close the popup if overlay is clicked
overlay.addEventListener('click', hidePopup);

// Add event listeners to each .content div
const contentDivs = document.querySelectorAll('.read-btn[data-popup]');
contentDivs.forEach(content => {
  content.addEventListener('click', function() {
    const popupText = this.getAttribute('data-popup');
    showPopup(popupText); // Show popup with corresponding content
  });
});